import React from 'react';
import { Col, Row } from 'react-bootstrap';
import SdkVersionTable from './SdkVersionTable';
import SdkVersionEvolution from './version/SdkVersionEvolution';
import AppVersionEvolution from './version/AppVersionEvolution';
import DevicePerSdkVersion from './version/DevicePerSdkVersion';
import DevicePerAppVersion from './version/DevicePerAppVersion';

const VersionTab = ({appId, filter, setFilter}) => {

  const filterOnVersion = (sdk_version, app_version) => {
    setFilter({ ...filter, sdk_version: [sdk_version], app_version: [app_version] })
  }

  return (
    <>
      <Row>
        <Col>
          <SdkVersionTable appId={appId} filter={filter} onRowClick={(row)=> filterOnVersion(row.sdk_version, row.app_version)}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <SdkVersionEvolution appId={appId} filter={filter}/>
        </Col>
        <Col>
          <DevicePerSdkVersion appId={appId} filter={filter}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <AppVersionEvolution appId={appId} filter={filter} />
        </Col>
        <Col>
          <DevicePerAppVersion appId={appId} filter={filter} />
        </Col>
      </Row>
    </>
  )
}

export default VersionTab
